import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLoggedUser } from "../../Redux/Actions/userActions";
import "./verify2FA.css";

const Verify2FA = () => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userId = sessionStorage.getItem("twoFactorUserId");

  const email = sessionStorage.getItem("twoFactorEmail");

  useEffect(() => {
    if (!userId) {
      navigate("/login");
    }
  }, [userId, navigate]);

  const handleVerify = async (e) => {
    e.preventDefault();

    setError("");

    if (!/^\d{6}$/.test(code)) {
      setError("Vendosni kodin 6-shifror.");

      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        "https://api.arkiva.gov.al/api/users/verify-2fa",
        {
          userId,
          code,
        },
      );

      const user = response.data.user;
      const token = response.data.token;

      // User is officially logged in now
      dispatch(
        setLoggedUser({
          id: user._id,
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          phone: user.phone,
          role: user.role,
          mustChangePassword: user.mustChangePassword,
        }),
      );

      localStorage.setItem("loggedUser_id", user._id);

      localStorage.setItem("token", token);

      sessionStorage.removeItem("twoFactorUserId");

      sessionStorage.removeItem("twoFactorEmail");

      // Keep your existing first-login logic
      if (user.mustChangePassword) {
        navigate("/change-password");
      } else {
        navigate("/manage/dashboard");
      }
    } catch (error) {
      console.error("2FA verification error:", error);

      setError(
        error.response?.data?.message ||
          "Kodi i verifikimit nuk është i saktë.",
      );
    } finally {
      setLoading(false);
    }
  };

  const returnToLogin = () => {
    sessionStorage.removeItem("twoFactorUserId");

    sessionStorage.removeItem("twoFactorEmail");

    navigate("/login");
  };

  return (
    <div className="two-factor-page">
      <div className="two-factor-modal">
        <div className="two-factor-icon">
          <i className="fa-solid fa-shield-halved"></i>
        </div>

        <h2>Verifikimi me dy hapa</h2>

        <p>Një kod 6-shifror është dërguar në:</p>

        <strong>{email}</strong>

        <form onSubmit={handleVerify}>
          <div className="two-factor-code">
            <input
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength="6"
              value={code}
              placeholder="000000"
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");

                setCode(value);
                setError("");
              }}
              autoFocus
            />
          </div>

          <p className="two-factor-info">Kodi është i vlefshëm për 5 minuta.</p>

          {error && (
            <div className="two-factor-error">
              <i className="fa-solid fa-circle-exclamation"></i>

              <span>{error}</span>
            </div>
          )}

          <button
            type="submit"
            className="two-factor-submit"
            disabled={loading || code.length !== 6}
          >
            {loading ? "Duke verifikuar..." : "Verifiko"}
          </button>

          <button
            type="button"
            className="two-factor-back"
            onClick={returnToLogin}
          >
            Kthehu te Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Verify2FA;
